'use strict';

angular.module('Login').provider('showErrorsConfig', function () {
    var _showSuccess;
    _showSuccess = false;
    this.showSuccess = function (showSuccess) {
        return _showSuccess = showSuccess;
    };
    this.$get = function () {
        return { showSuccess: _showSuccess };
    };
});



//////////////////
// WEBPACK FOOTER
// ./auth/js/providers/ErrorConfigProvider.js
// module id = 150
// module chunks = 0